import INFTCollections from '../../models/INFTCollections'
import AvaxCatsCard from '../../nftFormats/AvaxCats/Card/AvaxCatsCard'
import AvaxCatsDetail from '../../nftFormats/AvaxCats/Detail/AvaxCatsDetail'
import AvaxCatsActivityDetail from '../../nftFormats/AvaxCats/Activity/AvaxCatsActivityDetail'
import AvaxCatsLogo from '../../../../assets/nft-logo/AvaxCats.jpg'

export const AvaxCatsData: INFTCollections[] = [
  {
    id: 'AvaxCats',
    tokenAddress: '0x3155cd3C00FBBFE9C767465E1Ec8365A9C29d639',
    name: 'Avax Cats',
    cardFormat: AvaxCatsCard,
    detailFormat: AvaxCatsDetail,
    activityFormat: AvaxCatsActivityDetail,
    category: 1,
    creatorAddress: '0x954d517B5e588D20889bC3895403204F0686ed8b',
    logo: AvaxCatsLogo,
    website: 'https://www.avaxcats.com/',
    twitter: 'AVAXCATSNFT',
    telegram: 'https://t.me/AVAXCATS',
    discord: 'https://discord.com/invite/KNj8MCzq6M'
  }
]

export const AvaxCatsCategoryData = {
  [AvaxCatsData[0].tokenAddress.toLowerCase()]: AvaxCatsData[0].category
}
